import { fromJS, Map } from 'immutable';
import { ORDERS } from '@shared/constants';
import { STAFF_ACTIONS } from './actions';

export const initialState: Map<string, any> = fromJS({
  list: [],
  loading: false,
  offset: 0,
  count: 0,
  pageNumber: 1,
  error: false,
  order: ORDERS.ASC,
  sortBy: 'FULL_NAME',
  searchText: '',
});

export const staffReducer = (state = initialState, action: any = {}) => {
  const { type, payload } = action;
  switch (type) {
  case STAFF_ACTIONS.SET_LOADING_STATUS: {
    return state.set('loading', payload);
  }
  case STAFF_ACTIONS.SHOW_ERROR: {
    return state.set('error', true);
  }
  case STAFF_ACTIONS.SET_OFFSET: {
    return state.set('offset', payload);
  }
  case STAFF_ACTIONS.SET_STAFF: {
    return state.set('list', payload);
  }
  case STAFF_ACTIONS.SET_COUNT_STAFF: {
    return state.set('count', payload);
  }
  case STAFF_ACTIONS.SET_ORDER: {
    return state.set('order', payload);
  }
  case STAFF_ACTIONS.SET_SORT_BY: {
    return state.set('sortBy', payload);
  }
  case STAFF_ACTIONS.SET_PAGE_NUMBER: {
    return state.set('pageNumber', payload);
  }
  case STAFF_ACTIONS.SET_SEARCH_TEXT: {
    return state.set('searchText', payload);
  }
  default: {
    return state;
  }
  }
};
